document.addEventListener('DOMContentLoaded', () => {
  const tabsButtons = document.querySelectorAll('.button');
  const tabsContent = document.querySelectorAll('.item');

  const hideAllTabs = () => {
    tabsContent.forEach((tab) => (tab.style.display = 'none'));
  };

  const showTab = (tabId) => {
    document.getElementById(tabId).style.display = 'block';
  };

  const deactivateAllButtons = () => {
    tabsButtons.forEach((button) => {
      button.classList.remove('active');
    });
  };

  tabsButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const tabId = e.target.getAttribute('data-tab');
      hideAllTabs();
      deactivateAllButtons();
      showTab(tabId);
      e.target.classList.add('active');
    });
  });

  showTab('tools');
});

//   ЗАГРУЗКА ФАЙЛОВ
const fileInput = document.getElementById('upload-file-input');

const uploadFileBtns = document.querySelectorAll('.upload-file__btn');

uploadFileBtns.forEach((btn) => {
  btn.addEventListener('click', function () {
    fileInput.click();
  });
});

if (fileInput) {
  fileInput.addEventListener('change', function () {
    const fileName = this.files[0] ? this.files[0].name : 'Нет файла';
    console.log(fileName);
  });
}

// Сайдбар
const sidebarsWrapper = document.querySelector('.sidebars-wrapper');
const sidebar = document.querySelector('.sidebar');
const secondSidebar = document.querySelector('.second-sidebar');

const hideSidebarBtn = document.getElementById('sidebar-hide-btn');
const showSidebarBtn = document.getElementById('show-sidebar-btn');
const sidebarOverlay = document.querySelector('.sidebar__overlay');

let isSidebarVisible = window.innerWidth < 900;

// Скрыть сайдбар при загрузке, если экран меньше 900px
const checkWindowSize = () => {
  if (window.innerWidth < 900) {
    toggleSidebar(false);
    isSidebarVisible = false;
    showSidebarBtn.classList.add('active');
  } else if (!isSidebarVisible) {
    toggleSidebar(true);
    isSidebarVisible = true;
    showSidebarBtn.classList.remove('active');
  }
  sidebar.classList.remove('sidebar__show--mobile');
};

// Обработчик события для изменения размера окна
window.addEventListener('resize', checkWindowSize);

// Начальное состояние
checkWindowSize();

hideSidebarBtn.addEventListener('click', () => {
  toggleSidebar(false);
  sidebar.classList.toggle('sidebar__show--mobile');
});

showSidebarBtn.addEventListener('click', () => {
  toggleSidebar(true);
  sidebar.classList.toggle('sidebar__show--mobile');
});

sidebarOverlay.addEventListener('click', () => {
  toggleSidebar(false);
  sidebar.classList.toggle('sidebar__show--mobile');
});

function toggleSidebar(isVisible) {
  sidebarsWrapper.style.gap = isVisible ? '' : '6px';
  showSidebarBtn.classList.toggle('active', !isVisible);
  sidebarOverlay.classList.toggle('active', isVisible);
  sidebar.classList.toggle('sidebar--hidden', !isVisible);

  if (window.innerWidth < 900) {
    document.body.style.overflow = isVisible ? 'hidden' : '';
  } else {
    if (secondSidebar) {
      secondSidebar.classList.toggle('sidebar--hidden', !isVisible);
    }
    document.body.style.overflow = '';
  }
}
